import React, { createContext, useContext, useState, useEffect } from "react";
import { getThemeConfig } from "./_request";

// Default theme values
const defaultTheme = {
  colors: {
    primaryBG: "#F1FBFF",
    primary: "#009EDE",
    secondary: "#1BA2D4",
    grayFooter: "#797979",
    textBG: "#A7E6FF",
  },
  fonts: {
    nastaleeqKasheeda: '"Jameel Noori Nastaleeq Kasheeda"',
    nastaleeqRegular: '"Jameel Noori Nastaleeq Regular"',
    alMajeed: '"Al Majeed Quranic Font"',
  },
};

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(defaultTheme);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchThemeConfig = async () => {
      try {
        const config = await getThemeConfig();
        if (config && config.success) {
          setTheme({
            colors: config.data.colors || defaultTheme.colors,
            fonts: config.data.fonts || defaultTheme.fonts,
          });
        }
      } catch (error) {
        console.error("Error loading theme configuration:", error);
        // Fallback to default theme if there's an error
        setTheme(defaultTheme);
      } finally {
        setLoading(false);
      }
    };

    fetchThemeConfig();
  }, []);

  // Function to update theme dynamically
  const updateTheme = (newTheme) => {
    setTheme((prevTheme) => ({
      ...prevTheme,
      ...newTheme,
    }));
  };

  if (loading) {
    return null; // or a loading spinner
  }

  return (
    <ThemeContext.Provider value={{ theme, updateTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
};
